import {ICONS} from "../constants/icons";

export const tooltipData = {
  label: "Zweryfikowane przez eksperta",
  footerText: '<p>Dowiedz się więcej o naszym <a href="/o-nas/proces-redakcyjny">procesie redakcyjnym</a></p>'
}

export const summaryBarPopupItems = [
  {
    label: 'Dlaczego możesz nam zaufać',
    popup: {
      heading: 'Dlaczego możesz nam zaufać',
      // eslint-disable-next-line max-len
      description: 'Artykuły na HelloFinance są pisane na podstawie badań naukowych, danych ze stron rządowych oraz innych rzetelnych źródeł. Teksty powstają przy współpracy ze specjalistami ds. bankowości, finansów i ubezpieczeń. Artykuły są opiniowane przed publikacją oraz podczas znaczących aktualizacji.',
      link: {
        text: 'Dowiedz się więcej o naszym',
        label: 'procesie redakcyjnym',
        href: '/o-nas/proces-redakcyjny'
      }
    },
    icon: ICONS.shieldTick
  },
  {
    label: 'Informacja o reklamach',
    popup: {
      heading: 'Informacja o reklamach',
      // eslint-disable-next-line max-len
      description: 'Treści na HelloFinance mogą zawierać linki do produktów, ze sprzedaży których możemy dostać prowizję. Tworząc treści, trzymamy się wysokich standardów redakcyjnych i dbamy o obiektywne podejście do omawianych produktów. Obecność linków afiliacyjnych nie jest dyktowana przez naszych partnerów, a sami dobieramy produkty, które recenzujemy w pełni niezależnie.',
      link: {
        text: 'Dowiedz się więcej w naszym',
        label: 'regulaminie',
        href: '/regulamin'
      }
    },
    icon: ICONS.messageSmile
  }
];
